import React , {useEffect, useRef }from 'react';
import Formation from '../../componenents/vectors/formation';
import Managing from '../../componenents/vectors/managing';
import Digital from '../../componenents/vectors/digital';
import Marketing from '../../componenents/vectors/marketing';
import Transformation from '../../componenents/vectors/transformation';
import { useTranslation } from 'react-i18next';
import {motion} from 'framer-motion';
import { useGlobalContext } from '../../context';

function Solutions() {

    const {t} = useTranslation();
    const {initial, final, animation1, animation2, animation3, animation4, setSectionRef, sectionRef} = useGlobalContext();
    const expertiseRef = useRef(null);

useEffect(() => {
  setSectionRef({ ...sectionRef, expertise: expertiseRef });
}, [setSectionRef, sectionRef, expertiseRef]);

    return (
    <section 
        ref={expertiseRef}
        className="section solutions">
        <div className="container solutions__container">
            <div className="solutions__title_container">
                <motion.h2 
                initial={initial}
                whileInView={final}
                transition={animation1}
                viewport={{once: true}}
                className="solutions__title">{t('services.h2')}</motion.h2>
            </div>
            <div className="solutions__content_container">
                <div className="solution">
                    <motion.div
                    initial={initial}
                    whileInView={final}
                    transition={animation2}
                    viewport={{once: true}}
                    className="solution__icon__container">
                        <Transformation/>
                    </motion.div>
                    <motion.h3 
                    initial={initial}
                    whileInView={final}
                    transition={animation3}
                    viewport={{once: true}}
                    className="solution__title">{t('services.1.title')}</motion.h3>
                    <motion.p
                    initial={initial}
                    whileInView={final}
                    transition={animation4}
                    viewport={{once: true}}
                    className="solution__text" dangerouslySetInnerHTML={{ __html: t('services.1.text') }} />
                </div>
                <div className="solution">
                    <motion.div
                    initial={initial}
                    whileInView={final}
                    transition={animation2}
                    viewport={{once: true}}
                    className="solution__icon__container">
                        <Formation/>
                    </motion.div>
                    <motion.h3 
                    initial={initial}
                    whileInView={final}
                    transition={animation3}
                    viewport={{once: true}}
                    className="solution__title">{t('services.2.title')}</motion.h3>
                    <motion.p 
                    initial={initial}
                    whileInView={final}
                    transition={animation4}
                    viewport={{once: true}}
                    className="solution__text" dangerouslySetInnerHTML={{ __html: t('services.2.text') }} />
                </div>
                <div className="solution">
                    <motion.div
                    initial={initial}
                    whileInView={final}
                    transition={animation1}
                    viewport={{once: true}}
                    className="solution__icon__container">
                        <Managing/>
                    </motion.div>
                    <motion.h3
                    initial={initial}
                    whileInView={final}
                    transition={animation2}
                    viewport={{once: true}}
                    className="solution__title">{t('services.3.title')}</motion.h3>
                    <motion.p
                    initial={initial}
                    whileInView={final}
                    transition={animation3}
                    viewport={{once: true}}
                    className="solution__text" dangerouslySetInnerHTML={{ __html: t('services.3.text') }} />
                </div>
                <div className="solution">
                    <motion.div
                    initial={initial}
                    whileInView={final}
                    transition={animation1}
                    viewport={{once: true}}
                    className="solution__icon__container">
                        <Digital/>
                    </motion.div>
                    <motion.h3
                    initial={initial}
                    whileInView={final}
                    transition={animation2}
                    viewport={{once: true}}
                    className="solution__title">{t('services.4.title')}</motion.h3>
                    <motion.p
                    initial={initial}
                    whileInView={final}
                    transition={animation3}
                    viewport={{once: true}}
                    className="solution__text" dangerouslySetInnerHTML={{ __html: t('services.4.text') }} />
                </div>
                <div className="solution">
                    <motion.div
                    initial={initial}
                whileInView={final}
                transition={animation1}
                viewport={{once: true}}
                    className="solution__icon__container">
                        <Marketing/>
                    </motion.div>
                    <motion.h3
                    initial={initial}
                    whileInView={final}
                    transition={animation2}
                    viewport={{once: true}}
                    className="solution__title">{t('services.5.title')}</motion.h3>
                    <motion.p
                    initial={initial}
                    whileInView={final}
                    transition={animation3}
                    viewport={{once: true}}
                    className="solution__text" dangerouslySetInnerHTML={{ __html: t('services.5.text') }} />    
                </div>
            </div>
        </div>
    </section>
  )
}

export default Solutions;